/* unplugin-vue-components disabled */import { render } from "./MessageLoader.vue?vue&type=template&id=205ee90a"
const script = {}

import exportComponent from "/home/kenandlyhael/www/salehoo-mi/salehoo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__